/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Layout } from "antd";
import { styles } from "./styles";
import { Typography } from "../typography";
import { useWindowDimensions } from "@app/statics/dimensionContext";
import { ReactComponent as Instagram } from "@app/statics/svgs/instagram.svg";

//EXTRACTS
const { Footer } = Layout;

//RENDER
export const SiteFooter = () => {
  //CONTEXT
  const { isMobile } = useWindowDimensions();

  //RENDER
  return (
    <Footer css={styles.wrapper}>
      <section></section>
      <section>
        <Typography light>
          <>
            &copy; {new Date().getFullYear()} Songbird Perspective Inc.
            {isMobile ? <br /> : " - "}All rights reserved.
          </>
        </Typography>
        <Typography light>
          <>
            <span>
              Agave, Music & Media is a trademark of Songbird Perspective Inc.
            </span>
          </>
        </Typography>
      </section>
      <section css={styles.instagramIcon(isMobile)}>
        <a
          href="https://www.instagram.com/agavemusicmedia"
          target="_blank"
          rel="noopener"
        >
          <Instagram />
        </a>
      </section>
    </Footer>
  );
};
